export default __webpack_public_path__ + "img/homepage-recyclable-cover.asset.6a8614d0.jpg";